"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRouterConfigs = exports.setRouterConfigs = void 0;
const elements_core_di_1 = require("@hydrogen/elements.core.di");
elements_core_di_1.container.bind('RouterConfigs').toConstantValue([]);
const setRouterConfigs = (RouterConfigs) => (elements_core_di_1.container.rebind('RouterConfigs').toConstantValue(RouterConfigs));
exports.setRouterConfigs = setRouterConfigs;
const getRouterConfigs = () => (elements_core_di_1.container.get('RouterConfigs'));
exports.getRouterConfigs = getRouterConfigs;
//# sourceMappingURL=container.js.map